<template>
<div class="ti">
  <div style="margin-bottom:1px">
    <el-button size="mini" type="primary text2" @click="xiugai" v-if="state===1" >费用收付</el-button>
  </div>

  <div style="width: 80%;display: flex;flex-wrap: wrap;margin-bottom: 10px;margin-top: 10px;">
      <div>收款方式：</div>
      <div v-for="it in dataPay">
          <div style="margin-left: 10px;">
            <el-radio v-model="radio" :label="it.number">{{it.name}}</el-radio>
          </div>
      </div>
  </div>

  <div style="display: flex;color: red;">
    <!-- <div>总金额：￥{{yearMoney}}元</div> -->
    <div v-if="sumMoney>0">总金额：￥{{sumMoney}}元</div>
    <div v-else>总金额：￥{{yearMoney}}元</div>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__-120">
    <template v-slot:default>
      <thead>
      <tr>
        <th class="text-left">
          选择
          <el-checkbox v-if="state===1 && ERP.isPermission(4003007006)" v-model="checkbox_all" true-label='all'></el-checkbox>
        </th>
        <th class="text-left">房产</th>
        <th class="text-left">收费项</th>
        <th class="text-left">单价</th>
        <th class="text-left">用量面积</th>
        <th class="text-left">计费周期</th>
        <th class="text-left">应收日期</th>
        <th class="text-left">本期应收</th>
        <th class="text-left">本期欠费</th>
        <th class="text-left">减免金额</th>
        <th class="text-left">违约金</th>
        <th class="text-left">减免违约金</th>
        <th class="text-left">操作</th>
      </tr>
      </thead>
      <!-- 撤销 -->
      <tbody
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
      <tr class="text1" v-for="(item,index) in desserts" :key="item.id">
        <td>
          <div style="display: flex;">
            <div v-if="item.state==1 && ERP.isPermission(4003007006)">
              <el-checkbox v-if="index==0" v-model="checked.checked0" @change="checkeds(item.default_in_this_period,checked.checked0)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==1" v-model="checked.checked1" @change="checkeds(item.default_in_this_period,checked.checked1)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==2" v-model="checked.checked2" @change="checkeds(item.default_in_this_period,checked.checked2)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==3" v-model="checked.checked3" @change="checkeds(item.default_in_this_period,checked.checked3)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==4" v-model="checked.checked4" @change="checkeds(item.default_in_this_period,checked.checked4)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==5" v-model="checked.checked5" @change="checkeds(item.default_in_this_period,checked.checked5)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==6" v-model="checked.checked6" @change="checkeds(item.default_in_this_period,checked.checked6)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==7" v-model="checked.checked7" @change="checkeds(item.default_in_this_period,checked.checked7)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==8" v-model="checked.checked8" @change="checkeds(item.default_in_this_period,checked.checked8)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==9" v-model="checked.checked9" @change="checkeds(item.default_in_this_period,checked.checked9)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==10" v-model="checked.checked10" @change="checkeds(item.default_in_this_period,checked.checked10)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==11" v-model="checked.checked11" @change="checkeds(item.default_in_this_period,checked.checked11)" :true-label='item.id'></el-checkbox>
            </div>
            <div v-else>
              <el-checkbox disabled></el-checkbox>
            </div>
<!--            <div style="margin-left: 5px;">{{item.id}}</div>-->
          </div>
        </td>
        <td>{{item.h_name_date}}</td>
        <td style="text-align: left;">{{item.charge_name}}</td>
        <td>{{item.xsc_Price}}</td>
        <td >{{item.xsc_Amount}}</td>
        <td >
          {{item.min_date}} 至 {{item.max_date}}
        </td>
        <td>{{item.max_ymt}}</td>
        <td>{{item.receivable_in_the_current_period}}</td>
        <td>{{item.default_in_this_period}}</td>
        <td>
          <template v-if="state===1 && ERP.isPermission(4003007005)">
            <el-select
              v-model="item.discountType"
              :filterable = "true"
              size = "mini"
              :clearable = "true"
              placeholder="减免类型"
              style="width:100px;"
            >
              <el-option
                v-for="option in discountTypeOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value">
              </el-option>
            </el-select>
            <input style="width: 60px;border: 1px solid #eeeeee;background-color: #ffffff; text-align: center;" size="small" v-model="item.charge_1" :title="item.discount" @change="setTableMoney(index)" />
          </template>
          <template v-else>
            {{item.discount}}
          </template>
        </td>
        <td>{{item.delaySum}}</td>
        <td>
          <template v-if="state===1 && ERP.isPermission(4003007005)">
            <input style="width: 60px;border: 1px solid #eeeeee;background-color: #ffffff; text-align: center;" size="small" v-model="item.charges_1" :title="item.delayDiscount" @change="setTableMoney(index)" />
          </template>
          <template v-else>
            {{item.delayDiscount}}
          </template>
        </td>
        <td class="cdj_td">
          <div style="cursor:pointer;">
            <div @click="chakan(item)">详情</div>
          </div>
          <div style="cursor:pointer;" v-if="item.state==1 && ERP.isPermission(4003007005)">
            <div style="color: #1867c0;margin-left: 5px;" @click="reduction(item)">减免</div>
          </div>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
  <v-divider></v-divider>
  <div class="pages" v-if="desserts">
    <Page :total="total" :page-size="page" @on-change="change"  show-total />
  </div>
  <div class="zhanwu" v-else>没有数据</div>

  <Modal
    v-model="modal12"
    ok-text="确定"
    width="500"
    title="查看详情">
    <div v-if="chakana['id']">
      <p>ID：{{chakana['id']}}</p>
      <p>房产ID：{{chakana['house_id']}}</p>
      <p>生成组ID：{{chakana['weiyi']}}</p>
      <p>编号：{{chakana['number']}}</p>
      <p>姓名：{{chakana['h_name']}}</p>
      <p>组织id：{{chakana['company_id']}}</p>
      <p>项目：{{chakana.h_name_date}}</p>
      <p>收费项：<span v-if="chakana.charge_name">{{chakana.charge_name}}</span><span v-else>{{chakana.xsc_ChargeName}}</span></p>
      <p>实收金额：{{chakana['charge']}}</p>
      <p>应收金额：{{chakana['chargePay']}}</p>
      <p>减免金额：{{chakana['discount']}}</p>
      <p>违约金额：{{chakana['delaySum']}}</p>
      <p>违约天数：{{chakana['delayDays']}}</p>
      <p>减免违约金额：{{chakana['delayDiscount']}}</p>
      <p>已缴金额：{{chakana['PaidChargeSum']}}</p>
      <p>状态：<span v-if="chakana.state==1">待支付</span><span v-if="chakana.state==2">已完成</span></p>
      <p v-if="chakana.remark != ''">备注：{{chakana['remark']}}</p>
      <p>生成时间：{{chakana['generate_date']}}</p>
      <p v-if="chakana.ymt1=='' && chakana.explain==''">仪表编号：{{chakana['ybiao']}}</p>
      <p v-if="chakana.ymt1=='' && chakana.explain==''">抄表读数：{{chakana['chaobiaodushu']}}</p>
      <p v-if="chakana.ymt1==''">抄表人或负责人：{{chakana['chaobiaoname']}}</p>
      <p v-if="chakana.explain != ''">收费说明：{{chakana['explain']}}</p>
      <p>计费开始：{{chakana.startDate}}</p>
      <p><span >计费结束：{{chakana.endDate}}</span></p>
      <p v-if="chakana['log_name']!=null">后台付款操作人：{{chakana['log_name']}}</p>
    </div>
  </Modal>
  <!-- 减免 -->
  <Modal
    v-model="reductions"
    ok-text="确定"
    width="500"
    @on-ok="cdj_reduction"
    title="减免(折扣)">
    <div>
      <div>收费金额：{{order.charge}}</div>
      <div>应收金额：{{order.chargePay}}</div>
      <div>已缴金额：{{order.PaidChargeSum}}</div>
      <div>违约天数：{{order.delayDays}}</div>
      <div>违约金额：{{order.delaySum}}</div>
      <div>减免金额：{{order.discount}}</div>
      <div>减免违约金额：{{order.delayDiscount}}</div>
      <RadioGroup v-model="buttonSize" type="button" style="margin-top:10px">
        <Radio label="1">按金额减免</Radio>
        <Radio label="2">按百分比减免</Radio>
      </RadioGroup>
      <div style="margin-top: 10px;">减免金额公式：原总金额 - 减免金额 = 需支付金额</div>
      <div>减免违约金公式：原违约金总金额 - 减免金额 = 需支付金额</div>
      <div style="color: red;">注意：当前欠费金额 {{order.charge}} - {{order.PaidChargeSum}} = {{money_charge}}</div>
      <br>
      <template>
      减 免 类 型：
      <el-select
        v-model="discountType"
        :filterable = "true"
        size = "mini"
        :clearable = "true"
        placeholder="减免类型"
        style="width:100px;"
      >
        <el-option
          v-for="option in discountTypeOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value">
        </el-option>
      </el-select>
      </template>
      <div>
        减 免 金 额：{{priceCharge}} -
        <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charge">
        = {{price}}
        <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage">%</span>
      </div>
      <div style="margin-top: 3px;">
        减免违约金：{{Number(order.delaySum)}} -
        <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charges">
        = {{prices}}
        <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage1">%</span>
      </div>
    </div>
  </Modal>


  <!-- 打印display: none; -->
  <div style="position: absolute;bottom: 100px;left: 500px;width: 700px;display: none;">
    <div id='printBills'>
      <div style="font-size: 8px;color: #141414;font-family: 楷体;">
        <div style="width: 100%;text-align: center;margin-top: 30px;font-size: 20px;">中奥物业 收款收据</div>
        <div style="margin-top: 7px;display: flex;width: 100%;">
          <div style="width: 70%;">房号：{{goods1.h_name_date}}</div>
          <div style="width: 30%;margin-left: 220px;">付款方式：{{goods1.pays}}</div>
        </div>
        <div style="margin-top: 7px;display: flex;width: 100%;">
          <div style="width: 33%;">业主：{{goods1.h_name}}</div>
          <div style="width: 33%;">收据单号：{{goods1.bill_number}}</div>
          <div style="width: 34%;text-align: right;margin-right: 25px;">开票日期：{{goods1.date1}}</div>
        </div>
        <div style="margin-top:1px;line-height: 17px;">
          <table align="center" style="width: 100%;border-collapse: collapse;">
              <tr>
                  <th style="border:1px solid #000000;width: 150px;" align="center" valign="middle">收费项目</th>
                  <th style="border:1px solid #000000;width: 200px;" align="center" valign="middle">计费周期</th>
                  <th style="border:1px solid #000000;width: 90px;" class="ddd" align="center" valign="middle">面积</th>
                  <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">数量</th>
                  <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">单价</th>
                  <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">违约金</th>
                  <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">金额</th>
              </tr>
              <tr v-for="it in orders1">
                  <td style="border:1px solid #000000;" align="center" valign="middle">{{it.chargeitem_name}}</td>
                  <td style="border:1px solid #000000;" align="center" valign="middle">{{it.startDate}}-{{it.endDate}}</td>
                  <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charging}}</td>
                  <td style="border:1px solid #000000;" align="center" valign="middle">{{it.xsc_Amount}}</td>
                  <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charges}}</td>
                  <td style="border:1px solid #000000;" align="center" valign="middle">{{it.delaySum}}</td>
                  <td style="border:1px solid #000000;" align="center" valign="middle">{{it.charge}}</td>
              </tr>
              <tr>
                  <td style="border:1px solid #000000;" align="center" valign="middle">合计（大写）：</td>
                  <td style="border:1px solid #000000;text-align: left;" colspan="4" align="center" valign="middle">
                    <span style="margin-left: 5px;">{{capitalize1}}</span>
                  </td>
                  <td style="border:1px solid #000000;" align="center" valign="middle">（小写）：</td>
                  <td style="border:1px solid #000000;" align="center" valign="middle">{{goods1.charge}}</td>
              </tr>
              <tr>
                  <td style="border:1px solid #000000;" align="center" valign="middle">备注：</td>
                  <td style="border:1px solid #000000;text-align: left;" colspan="6" align="center" valign="middle">
                    <span style="margin-left: 5px;">{{goods1.beizhus}}</span>
                  </td>
              </tr>
          </table>
        </div>
        <div style="width: 70%;margin-top: 20px;">说明：第一联为存根（白色），第二联为客户（红色），第三联为记账（黄色）</div>
        <div style="margin-top: 7px;display: flex;width: 100%;">
          <div style="width: 33%;">开票人：{{login}}</div>
          <div style="width: 33%;">收款人：{{login}}</div>
          <div style="width: 34%;text-align: right;margin-right: 150px;">收款单位（盖章）</div>
        </div>
        <div style="margin-top: 7px;display: flex;width: 100%;">
          <div style="width: 33%;"></div>
          <div style="width: 33%;"></div>
          <div style="width: 34%;text-align: right;margin-right: 70px;">
            打印时间：{{goods1.date2}}
          </div>
        </div>
        <div style="text-align: center;margin-top: 7px;">打印次数<span style="margin-left: 30px;">{{goods1.frequency}}</span></div>
      </div>
    </div>
  </div>


</div>

</template>

<script>
  import print from 'print-js';
export default {
  name: 'OrderList3',
  // props:{
  //   year:{
  //     type:String|Number,
  //     default(){
  //       return ""
  //     }
  //   },
  //   roomName:{
  //     type: String,
  //     default() {
  //       return "";
  //     }
  //   },
  //   yearMoney:{
  //     type: String|Number,
  //     default() {
  //       return "";
  //     }
  //   },
  // },
  data () {
    return {
      chargeitemID:'',
      chargeitem:[],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      checked:{
        checked0:'',
        checked1:'',
        checked2:'',
        checked3:'',
        checked4:'',
        checked5:'',
        checked6:'',
        checked7:'',
        checked8:'',
        checked9:'',
        checked10:'',
        checked11:'',
      },
      money:'--',
      modal12:false,
      loading:false,
      reductions:false,
      datevalue:[],
       options: [
        {
          value: '',
          label: ''
        },],
       options1: [
        {
          id: 1,
          label: '编号'
        },
        {
          id: 2,
          label: '姓名'
        },
        {
          id: 3,
          label: '身份证'
        },
        {
          id: 4,
          label: '房产'
        },
        ],
      value: '',
      value1:'',
      value2:1,
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      chakana:[],
      state:0,
      order:{
        charge:0,
        chargePay:0,
        PaidChargeSum:0,
        discount:0,
        delaySum:0,
        delayDays:0,
        delayDiscount:0,
      },
      charge:0,
      price:0,
      charges:0,
      prices:0,
      priceCharge:0,
      itemOrder:[],
      homeName:'',
      startEndTime: {
        disabledDate:(time)=> {
          let year=this.year;
          let start_date=year+"-01-01"
          let end_date=year+"-12-31"
          let now_date=time.getTime();
          return (now_date<=(new Date(start_date).getTime())) || (now_date>=(new Date(end_date).getTime()))
        }
      },
      year:"",
      roomName:"",
      yearMoney:"",
      checkbox_all:"",
      sumMoney:0,
      dataPay:[],
      radio:'',
      money_charge:0,
      login:'',
      goods1:[],
      capitalize1:'',
      orders1:[],
      discountTypeOptions: [
        {
          value: '1',
          label: '空置减免'
        },
        {
          value: '2',
          label: '空关减免'
        },
        {
          value: '3',
          label: '零头减免'
        },
        {
          value: '4',
          label: '特殊减免'
        },
        {
          value: '5',
          label: '装修减免'
        },
        {
          value: '6',
          label: '反装修减免'
        },
        {
          value: '7',
          label: '导入减免'
        },
        {
          value: '-1',
          label: '违约金减免'
        }
      ],
      discountType: ""
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
     this.login = window.localStorage.getItem('login');
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
    });
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem = backdata.data.data;
    });
    //加载收款方式
    this.$myhttp.get('admin/OrderPayment/index',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
          let dataPay = backdata.data.data;
          this.dataPay = dataPay;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {

    //核销金额合计
    checkeds(money,checked){
      this.$myhttp.post('admin/Order/money',{checked:this.checked},{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.sumMoney = backdata.data.money;
      });
    },
    //导出
    excelPost(){
      if(this.state != 1){
        this.$Message.error('点击待付款，选择费用类型导出');
        return false;
      }
      if(this.chargeitemID == ''){
        this.$Message.error('费用类型不能为空');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.get('admin/getOrderExcel?id=1&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          // console.log(333);
          this.$Loading.finish();
      });
    },
    //查询总欠费
    moneys(){
      this.$myhttp.get('admin/getMoney?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.money = backdata.data['money'];
      });
    },
    setTableMoney(index){
      var that=this;
      that.order=this.desserts[index];
      that.charge=that.order.charge_1;
      that.charges=that.order.charges_1;
      that.discountType = that.order.discountType
      setTimeout(function () {
        that.cdj_reduction()
      },200);
    },
    //减免（折扣）
    cdj_reduction(){
      var order = this.order;
      //收费金额
      var charge = this.price;
      //减免收费金额
      var discount = this.charge;
      //违约金额
      var delaySum = this.prices;
      //减免违约金额
      var delayDiscount = this.charges;
      var discountType = this.discountType;
      var data = {
        id:order.id,
        charge:charge,
        discount:discount,
        delaySum:delaySum,
        delayDiscount:delayDiscount,
        discountType
      };
      var delaySum1 = Number(delaySum)+Number(delayDiscount);
      var charge1 = Number(charge)+Number(discount);
      if(delaySum1.toFixed(2) < Number(delayDiscount) || charge1.toFixed(2) < Number(discount)){
        // this.$Message.error('金额不合法');
        this.$alert('金额不合法', '提示')
        return false;
      }
      if(!data.discountType) {
        this.$Message.error('请选择减免类型');
        return false;
      }
      this.$myhttp.post('admin/orderDiscount',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.searchs();
          // this.$Message.success('操作成功!');
        this.$alert('操作成功!', '提示')
      });
    },
    //弹窗查看
    chakan(e){
      // console.log(e);
      this.chakana = e;
      this.modal12 = true;
    },
    //减免
    reduction(item){
      this.itemOrder = item;
      if(this.reductions == false){
        this.buttonSize = "1";
        this.reductions = true;
      }
      this.order = item;
      //当前欠费
      this.money_charge = Number(this.order.charge) - Number(this.order.PaidChargeSum);
      this.money_charge = this.money_charge.toFixed(2);

      var delaySum = Number(this.order.delaySum)-Number(this.order.delayDiscount);
      var priceCharge = Number(this.order.charge) + Number(this.order.discount) - delaySum;
      this.priceCharge = priceCharge.toFixed(2);//原总金额
      this.charge = Number(item.discount);
      var priceCharges = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.order.discount) + Number(this.order.delayDiscount);
      this.price = priceCharges.toFixed(2);//收费金额
      this.charges = Number(item.delayDiscount);
      var prices = Number(item.delaySum) - Number(item.delayDiscount);
      this.prices = prices.toFixed(2);
    },
    //确定付款(核销)
    xiugai(){
      let checked=this.checked;
      if(!(checked.checked0 || checked.checked1 || checked.checked2 || checked.checked3 || checked.checked4 || checked.checked5 || checked.checked6 || checked.checked7 || checked.checked8 || checked.checked9 || checked.checked10 || checked.checked11) ){
        this.$alert("请勾选收费项再进行核销！");
        return false;
      }
      if(this.radio == ""){
        this.$Message.error('请选择收款方式!');
        return false;
      }
      this.$confirm('金额可能包含违约金、如不缴违约金，请去手动减免违约金,确定核销吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/listXiuGai',{checked:this.checked,'radio':this.radio},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data.code == 201){
                this.$Message.error(backdata.data.message);
              }
              if(backdata.data.code == 200){
                this.checked={
                  checked0:'',
                  checked1:'',
                  checked2:'',
                  checked3:'',
                  checked4:'',
                  checked5:'',
                  checked6:'',
                  checked7:'',
                  checked8:'',
                  checked9:'',
                  checked10:'',
                  checked11:'',
                };
                this.prints(backdata.data.data.id)
                this.change(1)
                this.loading=false;
                this.$Message.success('操作成功!');
              }
          });
        }).catch(() => {

        });
    },


    //是否打印
    prints(id){
      this.$confirm('是否打印票据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.billPrintClick(id)
        }).catch(() => {

        });
    },
    //打印
     billPrintClick(ids){
      let item = {id:ids}
      let _this = this;
      this.login = window.localStorage.getItem('login');
      this.$myhttp.post('admin/getPrint',item,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            _this.goods1 = backdata.data.goods;
            _this.orders1 = backdata.data.order;
            _this.capitalize1 = _this.transCnMoney(_this.goods1.charge);
            _this.day();
      });
    },
    //数字转大写
    transCnMoney(number){
       var CN_MONEY = "";
       var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
          number =  parseFloat(number).toFixed(2).toString();//浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
       var dot = number.indexOf('.');//将从小数点开始分开
       if(dot >=0){
          number = number.substring(0,dot)+number.substr(dot+1,2);
          CN_UNIT=CN_UNIT.substr(CN_UNIT.length-number.length);
          for (var i = 0; i < number.length; i++){
           CN_MONEY += '零壹贰叁肆伍陆柒捌玖'.substr(number.substr(i, 1), 1) + CN_UNIT.substr(i, 1);
          }
          return CN_MONEY.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元");
        }else{

        }
    },
    //打印
    day(){
      let _this = this;
      setTimeout(function(){
        const style = '@page {margin:0 10mm};'//打印时去掉眉页眉尾
        printJS({
          printable: 'printBills',// 标签元素id
          type: 'html',
          header: '',
          targetStyles: ['*'],
          scanStyles:false,//打印必须加上，不然页面上的css样式无效
          style,
          //打开打印界面
          onLoadingStart: () => {
            // console.log('loading-start')
          },
          //界面打开成功结束
          onLoadingEnd: () => {
            // console.log('loading-end')
          },
          //关闭回调
          onPrintDialogClose: () => {
            // console.log("关闭回调")
          },
          onError: e => {
            // console.log('打印失败')
          },
        });
      },100)
    },


    modals(e){
      if(this.state != e){
        this.state = e;
        this.money = "--";
        this.change(1);
        // this.moneys();
      }
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      // console.log(this.datevalue)
      this.$myhttp.get('admin/orderList3?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID+"&homeName="+this.homeName+"&year="+this.year+"&room="+this.roomName+'&tm_limit='+this.datevalue.join(','),{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          let data=backdata.data
          this.desserts = (data[0]||[]).map(ret=>{
            ret.charge_1=ret.discount;
            ret.charges_1=ret.delayDiscount;
            return ret;
          });
          this.total = data[1];
          this.page = data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.money = "--";
      this.change(1);
      // this.moneys();
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/listDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                this.money = "--";
                this.change(1);
                this.$Message.success('删除成功!');
                // this.moneys();
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    // 树组件点击触发
    nodeClick(data) {
      this.sumMoney = 0;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      // console.log(data.tree)
      // this.homeName=tree_str;
      // this.change(1);
      this.value2=4;
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.change(1);
      }
    },
    setOptData({year,roomName,yearMoney,chargeId,state}){
      this.year=year
      this.roomName=roomName
      this.yearMoney=yearMoney
      this.chargeitemID=chargeId
      this.state=state

      var t = Date.parse(new Date()) / 1000;//时间戳
      var login = window.localStorage.getItem('login');
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/getorderList?login='+login,{
        'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value = backdata.data;
        this.$myhttp.get('admin/orderList3?id=1'+'&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID+"&homeName="+this.homeName+"&year="+this.year+"&room="+this.roomName+'&tm_limit='+this.datevalue.join(','),{
          'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = (backdata.data[0]||[]).map(ret=>{
            ret.charge_1=ret.discount;
            ret.charges_1=ret.delayDiscount;
            ret.discountType = "";
            return ret;
          });
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
          ERP.hideLoading()
        });
        // this.moneys();
      });
    }

  },
  watch:{
      charge(){
        var price = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.charge) + Number(this.order.delayDiscount);
        this.price = price.toFixed(2);
        if(this.price < 0){
          this.$Message.error('减免金额不合法');
          return false;
        }
      },
      charges(){
        var prices = Number(this.order.delaySum) - Number(this.charges);
        this.prices = prices.toFixed(2);
        if(this.prices < 0){
          this.$Message.error('减免违约金额不合法');
          return false;
        }
      },
      //减免是按金额减免还是按百分比减免切换
      buttonSize(){
        this.chargePercentage = '';
        this.chargePercentage1 = '';
        this.reduction(this.itemOrder);
      },
      //减免金额百分比
      chargePercentage(){
        this.charge = Number(this.priceCharge)*(Number(this.chargePercentage)/100);
        this.charge = this.charge.toFixed(2);
      },
      //减免违约金百分比
      chargePercentage1(){
        this.charges = Number(this.order.delaySum)*(Number(this.chargePercentage1)/100);
        this.charges = this.charges.toFixed(2);
      },
    checkbox_all:function (n) {
      if(!n){
        this.checked={
          checked0:'',
          checked1:'',
          checked2:'',
          checked3:'',
          checked4:'',
          checked5:'',
          checked6:'',
          checked7:'',
          checked8:'',
          checked9:'',
          checked10:'',
          checked11:'',
        }
      }else {
        this.checked={
          checked0:(this.desserts[0]||{}).ids||'',
          checked1:(this.desserts[1]||{}).ids||'',
          checked2:(this.desserts[2]||{}).ids||'',
          checked3:(this.desserts[3]||{}).ids||'',
          checked4:(this.desserts[4]||{}).ids||'',
          checked5:(this.desserts[5]||{}).ids||'',
          checked6:(this.desserts[6]||{}).ids||'',
          checked7:(this.desserts[7]||{}).ids||'',
          checked8:(this.desserts[8]||{}).ids||'',
          checked9:(this.desserts[9]||{}).ids||'',
          checked10:(this.desserts[10]||{}).ids||'',
          checked11:(this.desserts[11]||{}).ids||'',
        }
      }
      this.checkeds(1,1);
      //console.log(n,this.checked)
    }
  },

  components: {
    "erp-tree": () => import('../Common/erp-tree.vue')
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/List3.vue